// extracted by css-extract-rspack-plugin
export default {"QuestionPaneDetailLink":"bTzo8","QuestionPaneIcon":"_mQ8N","description":"MaDlB"};